import { DefaultLayout } from "layouts";
import { Home, About, Contact } from "pages";
import { Navigate } from "react-router-dom";

export const getRoutes = () => {
  return [
    {
      path: "",
      element: <DefaultLayout />,
      children: [
        {
          index: true,
          element: <Home />,
        },
        {
          path: "about",
          element: <About />,
        },
        {
          path: "contact",
          element: <Contact />,
        },
      ],
    },
    {
      path: "*",
      element: <Navigate to={"/"} replace />,
    },
  ];
};
